import { MessageBar, MessageBarType, MessageBarButton, useTheme } from '@fluentui/react';
import { useLanguageSettingsMessageBar } from '../hooks/useLanguageSettings';

export const LanguageSettingsMessageBar = () => {
    const { hasLanguageChanged, onSave, onRevert } = useLanguageSettingsMessageBar();
    const theme = useTheme();

    return (
        <>
            {hasLanguageChanged && (
                <MessageBar
                    messageBarType={MessageBarType.warning}
                    actions={
                        <>
                            <MessageBarButton onClick={onSave}>Save</MessageBarButton>
                            <MessageBarButton onClick={onRevert} style={{ marginRight: 10 }}>
                                Revert
                            </MessageBarButton>
                        </>
                    }
                    styles={{
                        root: {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            zIndex: 99999999,
                            color: theme.semanticColors.bodyText,
                        },
                    }}
                    isMultiline={false}
                >
                    You have unsaved language changes.
                </MessageBar>
            )}
        </>
    );
};
